export const BRAND = 'brand';
export const INVERSE = 'inverse';
export const NEUTRAL = 'neutral';

export const LOADING_SPINNER_COLORS = Object.freeze([BRAND, NEUTRAL, INVERSE]);

export default {
  BRAND,
  INVERSE,
  LOADING_SPINNER_COLORS,
  NEUTRAL,
};
